import React from 'react';
import CallDashboardPatientInfoForm from 'components/molecules/call-dashboard/forms/patient-info';

interface IProps {
  patientGuid: string;
}

const CallDashboardPatientInfoTab: React.FC<IProps> = (props) => {
  const { patientGuid } = props;

  return (
    <div>
      <CallDashboardPatientInfoForm patientGuid={patientGuid} />
    </div>
  );
};

export default CallDashboardPatientInfoTab;
